<!--
  Компонент для отображения индикатора обязательности поля.
  @props {Boolean} filled - Флаг, определяющий заполненность индикатора
-->
<template>
  <div class="w-[5px] h-[5px] rounded-full required-indicator" :class="filledClass"></div>
</template>


<script>
export default {
  name: 'RequiredIndicator',
  props: {
    filled: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    filledClass() {
      return this.filled ? 'bg-[#007832]' : 'bg-[#99203B]';
    },
  },
};
</script>

<style scoped>
.required-indicator {
  margin-top: 1.5px;
}
</style>
